import script from "./hide-results-button.vue?vue&type=script&lang=js"
export * from "./hide-results-button.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__